module.exports = __webpack_public_path__ + "img/pig4.3146a3ba.png";